import type { FaireProductEntity } from "../../entity_types/product";

export const p_5hw3e25m6s: FaireProductEntity = {
  token: "p_5hw3e25m6s",
  type: "product",
  name: "garden watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/8b2772505b0681f218d8365bff0d63076494412c9156bd39423e02c9c6ce9fb4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b1766ddb03bd78812f12d0ea15594c1b310a027dbde584677432879a069419f.jpeg",
    "https://cdn.faire.com/fastly/01febdeb2b9f578530ba35d2528e2fa28c3405f926e1086cbf72cc8c1ddeffa5.jpeg",
    "https://cdn.faire.com/fastly/3aed9865df0f501535686e8a393366e48fc5c241da6261a578ce0bf9d967193c.jpeg",
    "https://cdn.faire.com/fastly/916cf9c7d169329159269964468faa8113ba463e0515347f585f8ceacb62c03a.jpeg",
    "https://cdn.faire.com/fastly/49245fd3257fec744853bc8425f1b4f9a3e3db47887fd37bbc69e05873f3c6bd.jpeg",
    "https://cdn.faire.com/fastly/f86a3678c54506005ff27ca12967554513f8dc42e103e58efc3c289234214da1.jpeg",
    "https://cdn.faire.com/fastly/dbea4e41c882ea77dc8e2809b79c729a5cb51b3caed4efa229f3c51f9b484c1a.jpeg",
    "https://cdn.faire.com/fastly/697d8a909751d538b5aa641b1024d720c4fbef43f3d00f39b4cc191285ed5fa0.jpeg",
    "https://cdn.faire.com/fastly/a82fb4d3896323a54120502bf669b82e5feef5d900d2cd9277b04c51d4b97340.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve garden illustrations — a watering can, lavender pot, sun hat, wheelbarrow of flowers, garden tools, rain boots, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA strong spring and summer seller. Performs well in garden shops, home boutiques, and Mother's Day gifting displays.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:45.051Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
